'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('businessPlanningModule')

    .factory('initiativeUpdateStatusService', ['$http', 'env', function ($http, env) {

        var baseUrl = environment.apiUrl + '/Pilot/api/BusinessPlanning/InitiativeUpdateStatus';

        function returnData(response) {
            return response.data;
        }

        var service = {};

        // Get Owners And Status
        service.getOwnersAndStatus = function () {
            var reqUrl = baseUrl + '/OwnerAndStatus';

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // Send Reminder To Owner
        service.sendReminderToOwner = function (owner) {
            var reqUrl = baseUrl + '/OwnerAndStatus/Owner@' + owner.ItemPersonID + '/SendReminder';
            var isDebug = env.isDev || undefined;

            return $http
                .post(reqUrl, {
                          isDebug: isDebug,
                          owner: owner
                      })
                .then(returnData);
        };

        // GetAssessmentTasks
        service.getAssessmentTasks = function (assessorId) {
            var reqUrl = baseUrl + '/Assessor@' + assessorId + '/Task';

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // Get Assessments By Assessor
        service.getInitiativeAssessmentsByAssessor = function (assessorID) {
            var reqUrl = baseUrl + '/Assessor@' + assessorID + '/Initiative';

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // Get Assessments By Assessor and By Initiative
        service.getAssessmentsByAssessorAndInitiative = function (assessorID, planInitiativeId) {
            var reqUrl = baseUrl + '/Assessor@' + assessorID + '/Initiative/' + planInitiativeId;

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // Assess Deliverable
        service.assessDeliverable = function (assessorId, initiativeId, deliverableId, assessment) {
            var reqUrl = baseUrl + '/Assessor@' + assessorId + '/Initiative/' + initiativeId + '/Deliverable/' + deliverableId;

            return $http
                .post(reqUrl, { planDeliverableAssessment: assessment })
                .then(returnData);
        };

        // Reset Deliverable Assessment
        service.resetDeliverableAssessment = function (assessorId, initiativeId, deliverableId, assessment) {
            var reqUrl = baseUrl + '/Assessor@' + assessorId + '/Initiative/' + initiativeId + '/Deliverable/' + deliverableId + '/Reset';

            return $http
                .post(reqUrl,
                    { planDeliverableAssessment: assessment })
                .then(returnData);
        };

        // Get FollowUps by Plan Deliverable AssessmentID
        service.getFollowUpsByPlanDeliverableAssessmentID = function (assessorId, initiativeId, deliverableId, assessmentId) {
            var reqUrl = baseUrl + '/Assessor@' + assessorId + '/Initiative/' + initiativeId + '/Deliverable/' + deliverableId + '/Assessment/' + assessmentId + '/FollowUp';

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // Create Plan Deliverable Assessment FollowUp
        service.createPlanDeliverableAssessmentFollowUp = function (assessorId, initiativeId, deliverableId, assessmentId, followUp) {
            var reqUrl = baseUrl + '/Assessor@' + assessorId + '/Initiative/' + initiativeId + '/Deliverable/' + deliverableId + '/Assessment/' + assessmentId + '/FollowUp';

            return $http
                .post(reqUrl, followUp)
                .then(returnData);
        };

        // Get Download Attachment URL
        service.getDownloadAttachmentUrl = function (assessorId, initiativeId, deliverableId, assessmentId, attachmentId) {
            return baseUrl
                + '/Assessor@' + assessorId + '/Initiative/' + initiativeId
                + '/Deliverable/' + deliverableId + '/Assessment/' + assessmentId
                + '/FollowUp/Attachment/' + attachmentId;
        };

        // Get FollowUps for Reviewer by Plan Deliverable AssessmentID
        service.getFollowUpsForReviewerByPlanDeliverableAssessmentID = function (initiativeId, deliverableId, assessmentId) {
            var reqUrl = baseUrl + '/Initiative/' + initiativeId + '/Deliverable/' + deliverableId + '/Assessment/' + assessmentId + '/FollowUp';

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // Get FollowUps  by Plan Deliverable ID
        service.getFollowUpsByPlanDeliverableID = function (initiativeId, deliverableId) {
            var reqUrl = baseUrl + '/Initiative/' + initiativeId + '/Deliverable/' + deliverableId + '/FollowUp';

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // Create Plan Deliverable Review FollowUp
        service.createPlanDeliverableReviewFollowUp = function (initiativeId, deliverableId, assessmentId, followUp) {
            var reqUrl = baseUrl + '/Initiative/' + initiativeId + '/Deliverable/' + deliverableId + '/Assessment/' + assessmentId + '/FollowUp';

            return $http
                .post(reqUrl, followUp)
                .then(returnData);
        };

        // Assess Plan Initiative
        service.assessPlanInitiative = function (assessorID, planInitiativeAssessment) {
            var reqUrl = baseUrl + '/Assessor@' + assessorID + '/Initiative/' + planInitiativeAssessment.PlanInitiativeID;

            return $http
                .post(reqUrl, planInitiativeAssessment)
                .then(returnData);
        };

        // Get Assessments To Review By Assessor
        service.getAssessmentsToReviewByAssessor = function (assessorID) {
            //API/BusinessPlanning/InitiativeUpdateStatus/Assessor@{assessorId}/ToReview
            var reqUrl = baseUrl + '/Assessor@' + assessorID + '/ToReview';

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // Get Initiative Assessments To Review By Assessor
        service.getInitiativeAssessmentsToReviewByAssessor = function (assessorID) {
            var reqUrl = baseUrl + '/Assessor@' + assessorID + '/Initiative/ToReview';

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // Get Assessments To Review By Assessor and By Initiative
        service.getAssessmentsToReviewByAssessorAndInitiative = function (assessorID, planInitiativeId) {
            var reqUrl = baseUrl + '/Assessor@' + assessorID + '/Initiative/' + planInitiativeId + '/ToReview';

            return $http
                .get(reqUrl)
                .then(returnData);
        };

        // Review Plan Deliverable
        service.reviewPlanDeliverable = function (planInitiativeAssessment, planDeliverableAssessment) {
            //API/BusinessPlanning/InitiativeUpdateStatus/Reviewer@{reviewerId}/Initiative/{planInitiativeId}/Deliverable/{planDeliverableId}/Review
            var reqUrl = baseUrl
                + '/Initiative/' + planInitiativeAssessment.PlanInitiativeID
                + '/Deliverable/' + planDeliverableAssessment.MilestoneGroupID
                + '/Review';

            return $http
                .post(reqUrl, planDeliverableAssessment)
                .then(returnData);
        };

        // Review Plan Initiative
        service.reviewPlanInitiative = function (planInitiativeAssessment) {
            var reqUrl = baseUrl + '/Initiative/' + planInitiativeAssessment.PlanInitiativeID + '/Review';

            return $http
                .post(reqUrl, planInitiativeAssessment)
                .then(returnData);
        };

        // Unlock Plan Initiative
        service.unlockPlanInitiative = function (planInitiativeAssessment) {
            var reqUrl = baseUrl + '/Initiative/' + planInitiativeAssessment.PlanInitiativeID + '/Unlock';

            return $http
                .post(reqUrl, planInitiativeAssessment)
                .then(returnData);
        };

        // Lock Plan Initiative
        service.lockPlanInitiativeAssessment = function (planInitiativeAssessment) {
            var reqUrl = baseUrl + '/Initiative/' + planInitiativeAssessment.PlanInitiativeID + '/Lock';

            return $http
                .post(reqUrl, planInitiativeAssessment)
                .then(returnData);
        };

        // Get Eligible Assessment Creation Owners
        service.getEligibleAssessmentCreationOwners = function () {
            return $http
                .get(baseUrl + '/AssessmentCreationOwner')
                .then(returnData);
        };

        return service;
    }]);
